import { render, staticRenderFns } from "./retention.vue?vue&type=template&id=72205bf3&scoped=true"
import script from "./retention.vue?vue&type=script&lang=js"
export * from "./retention.vue?vue&type=script&lang=js"
import style0 from "./retention.vue?vue&type=style&index=0&id=72205bf3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72205bf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72205bf3')) {
      api.createRecord('72205bf3', component.options)
    } else {
      api.reload('72205bf3', component.options)
    }
    module.hot.accept("./retention.vue?vue&type=template&id=72205bf3&scoped=true", function () {
      api.rerender('72205bf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/retention.vue"
export default component.exports